import React from "react";
import * as Icons from "lucide-react";
import { ArrowRight, Sparkles, Clock, QrCode } from "lucide-react";
import { luciaFeatures, clinic } from "../mock";

export default function Lucia() {
  return (
    <section id="lucia" className="section-navy text-white">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-20 lg:py-28">
        <div className="grid lg:grid-cols-2 gap-14 items-center">
          <div>
            <span className="reveal inline-flex items-center gap-2 rounded-full bg-white/10 border border-white/15 px-4 py-1.5 text-xs font-medium text-blue-200">
              <Sparkles size={14} /> Nuevo · IA médica de salud visual
            </span>
            <h2 className="reveal font-display font-extrabold text-3xl lg:text-[2.8rem] leading-tight mt-5">
              Conoce a <span className="text-gradient-blue">LucIA</span>
            </h2>
            <p className="reveal text-lg text-blue-100/85 mt-3 font-medium">
              Tu guía inteligente en Salud Visual
            </p>
            <p className="reveal text-blue-100/70 mt-4 leading-relaxed max-w-xl">
              Responde tus dudas sobre cataratas, glaucoma, retina y más patologías oculares.
              Accede a tu informe médico, realiza un test rápido de síntomas y agenda tu hora,
              todo en un solo lugar y disponible 24/7.
            </p>

            <div className="reveal flex flex-col sm:flex-row gap-3 mt-8">
              <button
                onClick={() => window.dispatchEvent(new Event("open-lucia"))}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-white text-[#0b2545] rounded-full h-12 px-7 font-semibold shadow-xl shadow-blue-950/30 hover:bg-blue-50 transition-colors"
              >
                Habla con LucIA <ArrowRight size={18} />
              </button>
              <div className="inline-flex items-center gap-2 text-sm text-blue-100/70">
                <Clock size={16} /> Disponible 24/7 · Aquí mismo, sin salir del sitio
              </div>
            </div>

            <div className="reveal mt-8 inline-flex items-center gap-4 glass-card rounded-2xl p-4 pr-6">
              <div className="bg-white rounded-xl p-1.5 shrink-0">
                <img
                  src={clinic.qrLucia}
                  alt="Código QR para hablar con LucIA"
                  className="w-24 h-24 object-contain rounded-lg"
                />
              </div>
              <div>
                <div className="flex items-center gap-1.5 font-display font-bold text-white">
                  <QrCode size={16} className="text-blue-200" /> Escanea y habla con LucIA
                </div>
                <p className="text-sm text-blue-100/70 mt-1 max-w-[220px] leading-relaxed">
                  Apunta la cámara de tu teléfono al código y conversa con LucIA al instante.
                </p>
              </div>
            </div>
          </div>

          <div className="grid sm:grid-cols-2 gap-4">
            {luciaFeatures.map((f, i) => {
              const Icon = Icons[f.icon] || Icons.Sparkles;
              return (
                <div
                  key={f.title}
                  className="reveal glass-card rounded-2xl p-6"
                  style={{ transitionDelay: `${(i % 2) * 80}ms` }}
                >
                  <div className="w-11 h-11 rounded-xl bg-blue-500/20 border border-blue-400/25 grid place-items-center text-blue-200">
                    <Icon size={20} />
                  </div>
                  <h3 className="font-display font-bold mt-4">{f.title}</h3>
                  <p className="text-sm text-blue-100/65 mt-1.5 leading-relaxed">{f.desc}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
